import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import emailjs from 'emailjs-com';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs';
import Services from '../pages/Services';
import LifeVoice from '../pages/LifeVoice';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsAndConditions from '../pages/Terms&conditions';
import Blog from '../pages/Blog';
import ContactUs from '../pages/ContactUs';
import ScrollToTop from '../components/ScrollToTop'; // Import the ScrollToTop component
import ChatBot from '../components/chatBot/ChatBot';
import PricingAndRefundPolicy from '../pages/PricingAndRefundPolicy';
import DunsSeal from '../components/Duns';

const App = () => {
  // Global Join Now Modal State
  const [showSplash, setShowSplash] = useState(true);
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [form, setForm] = useState({ name: '', mobile: '', city: '' });
  const [formErrors, setFormErrors] = useState({});
  const [formStatus, setFormStatus] = useState('');

  useEffect(() => {
    const splashTimer = window.setTimeout(() => setShowSplash(false), 1400);
    return () => window.clearTimeout(splashTimer);
  }, []);

  // Listen for custom event from Header
  useEffect(() => {
    const handleOpenJoinNowModal = () => setShowJoinModal(true);
    window.addEventListener('openJoinNowModal', handleOpenJoinNowModal);
    return () => {
      window.removeEventListener('openJoinNowModal', handleOpenJoinNowModal);
    };
  }, []);

  // EmailJS send function (user must configure IDs)
  const sendJoinRequest = async (e) => {
    e.preventDefault();
    setFormStatus('');
    // Validation
    const errors = {};
    if (!form.name.trim()) errors.name = 'Name is required';
    if (!/^\d{10}$/.test(form.mobile)) errors.mobile = 'Enter a valid 10-digit mobile number';
    if (!form.city.trim()) errors.city = 'City is required';
    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;
    setFormStatus('Sending...');
    try {
      if (typeof emailjs !== 'undefined' && emailjs.send) {
        await emailjs.send(
          'service_wopctcd',
          'template_2octgbn',
          {
            from_name: form.name,
            from_mobile: form.mobile,
            from_city: form.city,
            to_email: 'info@ev91riderz.com',
            time: new Date().toISOString(),
          },
          'P1G-nYFTVU0tjs5KP'
        );
      } else if (window.emailjs && window.emailjs.send) {
        await window.emailjs.send(
          'service_wopctcd',
          'template_2octgbn',
          {
            from_name: form.name,
            from_mobile: form.mobile,
            from_city: form.city,
            to_email: 'info@ev91riderz.com',
            time: new Date().toISOString(),
          },
          'P1G-nYFTVU0tjs5KP'
        );
      } else {
        throw new Error('EmailJS is not configured.');
      }
      setFormStatus('Request sent! We will contact you soon.');
      setForm({ name: '', mobile: '', city: '' });
    } catch (err) {
      setFormStatus('Failed to send. Please try again later.');
    }
  };

  return (
    <Router>
      {showSplash && (
        <div className="ev91-splash-screen" aria-label="EV91 loading">
          <span>EV91</span>
        </div>
      )}
      <ScrollToTop />
      <Header />
      <main className="min-h-screen pt-24">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/life-voice" element={<LifeVoice />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route
  path="/pricing-and-refund-policy"
  element={<PricingAndRefundPolicy />}
/>
        </Routes>
      </main>
      <Footer />
      {/* Global Join Now Modal */}
      {showJoinModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/75 px-3 backdrop-blur-sm">
          <div className="relative mx-auto max-h-[95vh] w-full max-w-md overflow-y-auto rounded-[2rem] border border-emerald-100 bg-white p-5 shadow-2xl shadow-emerald-900/30 sm:p-7 md:p-8">
            <button
              className="absolute right-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-slate-100 text-2xl font-bold text-slate-500 transition hover:bg-emerald-50 hover:text-emerald-700"
              onClick={() => { setShowJoinModal(false); setFormStatus(''); setFormErrors({}); }}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="mb-6 pr-10">
              <p className="text-sm font-bold uppercase tracking-[0.22em] text-emerald-600">EV91 Onboarding</p>
              <h2 className="mt-2 text-3xl font-black text-slate-950">Get EV</h2>
              <p className="mt-2 text-sm text-slate-500">Share your city and contact number. The EV91 team will reach out.</p>
            </div>
            <form onSubmit={sendJoinRequest} className="space-y-4">
              <div>
                <label className="mb-1 block text-sm font-bold text-slate-700">Your Name</label>
                <input
                  type="text"
                  className={`w-full rounded-2xl border bg-slate-50 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-emerald-400 ${formErrors.name ? 'border-red-500' : 'border-slate-200'}`}
                  value={form.name}
                  onChange={e => setForm({ ...form, name: e.target.value })}
                  required
                />
                {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
              </div>
              <div>
                <label className="mb-1 block text-sm font-bold text-slate-700">Mobile</label>
                <input
                  type="tel"
                  className={`w-full rounded-2xl border bg-slate-50 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-emerald-400 ${formErrors.mobile ? 'border-red-500' : 'border-slate-200'}`}
                  value={form.mobile}
                  onChange={e => setForm({ ...form, mobile: e.target.value.replace(/[^0-9]/g, '') })}
                  maxLength={10}
                  required
                />
                {formErrors.mobile && <p className="text-red-500 text-xs mt-1">{formErrors.mobile}</p>}
              </div>
              <div>
                <label className="mb-1 block text-sm font-bold text-slate-700">City</label>
                <select
                  className={`w-full rounded-2xl border bg-slate-50 px-4 py-3 focus:outline-none focus:ring-2 focus:ring-emerald-400 ${formErrors.city ? 'border-red-500' : 'border-slate-200'}`}
                  value={form.city}
                  onChange={e => setForm({ ...form, city: e.target.value })}
                  required
                >
                  <option value="">Select City</option>
                  <option value="Bengaluru">Bengaluru</option>
                  <option value="Chennai">Chennai</option>
                  <option value="Hyderabad">Hyderabad</option>
                  <option value="Delhi">Delhi</option>
                  <option value="Mumbai">Mumbai</option>
                </select>
                {formErrors.city && <p className="text-red-500 text-xs mt-1">{formErrors.city}</p>}
              </div>
              <button
                type="submit"
                className="w-full rounded-2xl bg-slate-950 py-3 font-black text-white transition hover:-translate-y-0.5 hover:bg-emerald-700"
                disabled={formStatus === 'Sending...'}
              >
                {formStatus === 'Sending...' ? 'Sending...' : 'Submit'}
              </button>
              {formStatus && <p className={`text-center mt-2 ${formStatus.includes('sent') ? 'text-green-600' : 'text-red-500'}`}>{formStatus}</p>}
            </form>
          </div>
        </div>
      )}
      <DunsSeal />
      <ChatBot />
    </Router>
  );
};

export default App;
